// components/head.js
import * as React from 'react';
import NextHead from 'next/head';

import { HeadProps } from 'head/types';

export const Head = ({ children, title }: HeadProps) => (
  <NextHead>
    <meta charSet='UTF-8' />
    <meta name='viewport' content='width=device-width, initial-scale=1.0' />
    <meta name='Nadine Pesso | Full-Stack Developer' content='Portfolio' />
    <meta httpEquiv='x-ua-compatible' content='ie=edge' />

    <title>{title}</title>

    {children}
  </NextHead>
);
